/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["[_nghost-%COMP%]{background-color:#e9f3fc;display:block;padding:5px}ol[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };

